module.exports = "table {\n  height: 735px;\n  display: -moz-groupbox; }\n  table tbody {\n    overflow-y: scroll;\n    height: 680px;\n    width: 100%;\n    position: absolute; }\n  table tbody tr {\n      width: 100%;\n      display: inline-table;\n      table-layout: fixed; }\n  table tbody tr:last-child td {\n        border-bottom: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/dashboards/pages/dashboard/dashboard.component.scss
// module id = ./apps/eyewatch/src/app/eyewatch/dashboards/pages/dashboard/dashboard.component.scss
// module chunks = main